import colors from '@service-victoria/component-library/utils/colors';
import styled from 'styled-components';

export const CssWrapper = styled.div`
  line-height: 24px;
  letter-spacing: -0.3px;
  font-size: 16px;
  color: ${colors.blueGrey};

  h3 {
    font-weight: 600;
    font-size: 18px;
  }

  a {
    color: ${colors.brown};

    &:hover,
    &:active {
      color: ${colors.teal};
    }
  }

  ul {
    padding: 6px 0 6px 40px;
    margin-bottom: 0;
  }

  li {
    padding: 6px 0;
  }

  p {
    margin-bottom: 0;
  }

  .vh {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
    white-space: nowrap;
  }
`;
